import { InformationRequest } from '../../lib/types/models/information-request/information-request'
import { InformationRequestInput } from '../../lib/types/models/information-request/information-request-input'
import { UpdateInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function updateInformationRequest(data: UpdateInput<InformationRequestInput>) {
  const { id, ...rest } = data
  return restApiClient
    .url(constructApiUrl(API.informationRequests.update.url, { id }))
    .patch<InformationRequest, Partial<InformationRequestInput>>(rest)
}
